module.exports = __webpack_public_path__ + "img/Wp_2092.392b5115.png";